import { DocumentType } from '@/core/enums/document-type';
import { OtpChannel } from '@/core/enums/otp-channel.enum';
import { z } from 'zod';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const userSignupRequestOtpSchema = z
  .object({
    id: z.uuid('Id is required'),
    documentType: z.enum(DocumentType, {
      error: 'Document type is required',
    }),

    documentNo: z.string().trim().min(1, 'Document number is required'),

    firstName: z.string().trim().min(1, 'First name is required'),
     turnstileToken: z
  .string()
  .min(1, 'Please complete the security verification.'),


    otpChannel: z.enum(OtpChannel, {
      error: 'OTP channel is required',
    }),

    phoneNumber: z.string().optional(),

    email: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.otpChannel === OtpChannel.Sms) {
      if (!data.phoneNumber?.trim()) {
        ctx.addIssue({
          code: 'custom',
          path: ['phoneNumber'],
          message: 'Phone number is required',
        });
      } else if (!isValidPhoneNumber(data.phoneNumber)) {
        ctx.addIssue({
          code: 'custom',
          path: ['phoneNumber'],
          message: 'Valid phone number is required',
        });
      }
    }

    if (data.otpChannel === OtpChannel.Email && !z.email().safeParse(data.email).success) {
      ctx.addIssue({
        code: 'custom',
        path: ['email'],
        message: 'Email address is required',
      });
    }
  });

export type UserSignupRequestOtpFormValues = z.infer<typeof userSignupRequestOtpSchema>;
